import script from "./issueForm.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./issueForm.component.vue?vue&type=script&lang=ts&setup=true"

import "./issueForm.component.vue?vue&type=style&index=0&id=66dc15a4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66dc15a4"]])

export default __exports__